/**
 * Translations for the bulk sheets configurator (/kreator/arkusze).
 * Glossary: sticker/Aufkleber/adesivo/autocollant, kiss-cut/Kiss-Cut/kiss-cut/découpe kiss-cut,
 * laminate/Laminat/laminato/pellicule de lamination, sheet/Bogen/foglio/feuille,
 * area/Fläche/superficie/surface, design/Design/progetto/projet, order/Bestellung/ordine/commande,
 * print/Druck/stampa/impression, piece/Stück/pezzo/pièce.
 */
export const sheetsTranslations = {
  pl: {
    "sh.switch.custom.title": "Naklejki na wymiar",
    "sh.switch.custom.desc": "kiss-cut lub die-cut, z laminatem",
    "sh.switch.sheets.title": "Naklejki hurtowe na arkuszach",
    "sh.switch.sheets.desc": "kiss-cut, bez laminatu, od 0,5 m²",
    "sh.seo.title": "Naklejki hurtowe na arkuszach – wycena za m² | Stickers Tattooo",
    "sh.seo.description": "Naklejki nacinane na arkuszu bez laminatu, rozliczane za powierzchnię folii. Minimum 0,5 m², kolejne co 0,5 m². Ten sam druk i folie co w naklejkach premium.",
    "sh.h1": "Naklejki hurtowe na arkuszach",
    "sh.intro.1": "Naklejki nacinane na arkuszu, bez laminatu — na produkty, do zaklejania paczek, kopert i opakowań lub do samodzielnego pocięcia na sztuki.",
    "sh.intro.strong1": "Ten sam druk i te same folie co w naklejkach premium",
    "sh.intro.2": "— różnicą jest brak laminatu. Rozliczane za powierzchnię folii, nie za sztukę. Minimum 0,5 m², kolejne co 0,5 m². Od 1 m² obowiązuje standardowa stawka za metr.",
    "sh.intro.strong2": "Możesz zamówić naklejki w dowolnym kształcie",
    "sh.intro.3": "— prostokąt, kwadrat, owal, koło lub niestandardowy kontur.",
    "sh.hero.alt": "Arkusz naklejek Stickers.tattooo — gotowe do samodzielnego odklejania lub pocięcia",
    "sh.foil.label": "Rodzaj folii",
    "sh.lam.label": "Laminat",
    "sh.lam.none": "Bez laminatu",
    "sh.lam.matte": "Laminat matowy",
    "sh.lam.gloss": "Laminat błyszczący",
    "sh.sum.laminate": "Laminat",
    "sh.foil.prices": "Ceny brutto dla tej folii:",
    "sh.foil.perHalf": "za 0,5 m²",
    "sh.foil.perM2From": "za m² od 1 m²",
    "sh.foil.netPerM2": "netto / m² od 1 m²",
    "sh.foil.holoNote": "Nadruk na foliach holograficznych bez białego poddruku prześwituje — grafika przejmuje połysk folii. Jeśli zależy Ci na wiernych kolorach, napisz do nas przed zamówieniem.",
    "sh.area.label": "Powierzchnia",
    "sh.area.aria": "Powierzchnia w m²",
    "sh.area.small": "mały format",
    "sh.area.note": "Zamówienie realizujemy w arkuszach o wymiarach 0,5 m × 1 m lub zbliżonych — dokładny format zależy od wielkości i układu naklejek. Przy większych zamówieniach dzielimy nadruk na kilka arkuszy. Łączna liczba sztuk zawsze odpowiada tej podanej w wyliczeniu. Jako drukarnia wielkoformatowa jesteśmy jednak w stanie wykonać naklejkę w dowolnym rozmiarze — nawet kilkumetrową, w jednym kawałku. Wykonujemy również duże naklejki na witryny, szyby i inne powierzchnie wielkoformatowe.",
    "sh.err.foil": "Wybierz rodzaj folii",
    "sh.err.minArea": "Minimalne zamówienie to 0,5 m²",
    "sh.err.step": "Powierzchnię zwiększaj co 0,5 m²",
    "sh.err.maxArea": "Maksymalna powierzchnia to 50 m²",
    "sh.err.dims": "Podaj wymiary naklejki",
    "sh.err.minDim": "Minimalny wymiar naklejki to 5 mm",
    "sh.err.minGap": "Minimalny odstęp między naklejkami to 3 mm",
    "sh.err.noFit": "Naklejka nie mieści się na zamówionej powierzchni",
    "sh.dims.label": "Wymiary naklejki",
    "sh.dims.width": "Szerokość",
    "sh.dims.height": "Wysokość",
    "sh.dims.unit.mm": "milimetry",
    "sh.dims.unit.cm": "centymetry",
    "sh.dims.gap": "Odstęp (mm)",
    "sh.gap.butt": "0 mm — na styk",
    "sh.butt.title": "Cięcie na styk (bez odstępu)",
    "sh.butt.sub": "więcej naklejek z tego samego metrażu",
    "sh.butt.note": "Opcja cięcia na styk stosuje się tylko przy naklejkach kwadratowych / prostokątnych. Naklejki są cięte jedna przy drugiej, bez marginesu.",
    "sh.butt.unavailable": "Cięcie na styk jest dostępne tylko dla naklejek prostokątnych i kwadratowych.",
    "sh.stats.total": "Naklejek łącznie",
    "sh.stats.perM2": "Naklejek na 1 m²",
    "sh.file.label": "Pliki projektu",
    "sh.file.watermark": "MAX 3 PROJEKTY / ZAMÓWIENIE",
    "sh.file.uploading": "Wgrywanie...",
    "sh.file.prompt": "Przeciągnij pliki lub kliknij, aby wybrać",
    "sh.file.counterSuffix": "plików",
    "sh.up.title": "Trwa przesyłanie plików…",
    "sh.up.wait": "Prosimy o cierpliwość, to może chwilę potrwać.",
    "sh.up.remaining": "pozostało",
    "sh.up.dontClose": "Nie zamykaj strony podczas przesyłania",
    "sh.up.cancel": "✕ Anuluj wgrywanie",
    "sh.max3.title": "Maksymalnie 3 projekty w jednym zamówieniu",
    "sh.max3.desc": "W jednym zamówieniu możesz przygotować maksymalnie 3 projekty i dodać do 6 plików — dodatkowe pliki to ewentualne kontury cięcia. Jeśli masz więcej projektów, skonfiguruj kolejne zamówienie osobno i dodaj je do koszyka jako kolejną pozycję.",
    "sh.file.previewAlt": "Podgląd",
    "sh.file.remove": "Usuń plik",
    "sh.file.noPreview": "Plik został wgrany poprawnie. Dla tego formatu podgląd może nie być dostępny.",
    "sh.notice.title": "Pamiętaj: maksymalnie 3 projekty (do 6 plików) na zamówienie",
    "sh.notice.desc": "Jeśli masz więcej plików, dodaj kolejne jako osobną pozycję w koszyku.",
    "sh.req.1a": "plik w rozmiarze zamawianej powierzchni (",
    "sh.req.1b": "), ze spadem 3 mm",
    "sh.req.2": "linie cięcia jako osobna warstwa lub kolor dodatkowy CutContour",
    "sh.req.3": "minimalny odstęp między naklejkami 3 mm",
    "sh.req.4": "maksymalnie 3 projekty (do 6 plików z konturami cięcia) na zamówienie — więcej projektów dodaj jako osobne pozycje w koszyku",
    "sh.faq.title": "Najczęstsze pytania",
    "sh.faq.q1": "Czy mogę pociąć arkusz na pojedyncze naklejki?",
    "sh.faq.a1": "Naklejki są nacięte po obrysie, więc odklejasz je pojedynczo z arkusza. Jeśli wolisz mieć osobne sztuki — np. do dołączania do przesyłek — możesz rozciąć arkusz nożyczkami wzdłuż odstępów między naklejkami. Zostawiamy między nimi 3 mm marginesu właśnie po to.",
    "sh.faq.q2": "Dlaczego nie mogę ustawić odstępu mniejszego niż 3 mm?",
    "sh.faq.a2": "Poniżej 3 mm nóż plotera potrafi podrywać sąsiednią naklejkę przy odklejaniu. To ograniczenie techniczne, nie preferencja.",
    "sh.faq.q3": "Jakie wymiary ma arkusz?",
    "sh.faq.a3": "Rozliczamy powierzchnię, nie format. Proporcje arkusza zależą od szerokości folii dostępnej w danej partii — gwarantujemy powierzchnię i liczbę naklejek.",
    "sh.faq.q4": "Czym różnią się od naklejek premium?",
    "sh.faq.a4": "Druk i folie są identyczne. Różnica to brak laminatu, przez co nadruk jest mniej odporny na zarysowania i obtarcia. Ale jest nadal odporny na wodę, słońce, warunki atmosferyczne.",
    "sh.faq.q5": "Czy mogę wgrać kilka różnych projektów do jednego zamówienia?",
    "sh.faq.a5": "3 projekty = 1 zamówienie w koszyku. W jednym zamówieniu możesz przygotować maksymalnie 3 projekty i dodać do 6 plików — dodatkowe pliki to ewentualne kontury cięcia. Jeśli masz więcej projektów, skonfiguruj kolejne zamówienie osobno i dodaj je do koszyka jako kolejną pozycję.",
    "sh.sum.title": "Podsumowanie zamówienia",
    "sh.sum.foil": "Rodzaj folii",
    "sh.sum.area": "Powierzchnia",
    "sh.sum.pricePerM2": "Cena za m²",
    "sh.sum.size": "Wymiar naklejki",
    "sh.sum.gap": "Odstęp",
    "sh.sum.total": "Naklejek łącznie",
    "sh.sum.surcharge": "Dopłata za małe naklejki (+20%)",
    "sh.sum.volume": "Rabat ilościowy",
    "sh.vol.next": "Zamów od {a} m², aby otrzymać {p}% rabatu.",
    "sh.vol.note": "Rabat ilościowy nie łączy się z rabatem powitalnym ani indywidualnym — naliczamy ten korzystniejszy.",
    "sh.sum.ship": "Wysyłka do",
    "sh.sum.gross": "brutto",
    "sh.sum.net": "netto",
    "sh.sum.perPiece": "/ szt.",
    "sh.upsell.a": "Za 1 m² dopłacisz tylko",
    "sh.upsell.b": ", a otrzymasz dwa razy więcej naklejek.",
    "sh.warn.a": "Naklejki bez laminatu. Nadruk jest odporny na wodę, słońce i warunki atmosferyczne — na zewnątrz wytrzymuje około 3 lat. Brak laminatu oznacza jednak mniejszą odporność na uszkodzenia mechaniczne: naklejka może się zarysować lub przetrzeć. Jeśli ma trafić na butelkę, kubek albo laptopa, czyli tam, gdzie jest często dotykana i pocierana, wybierz naklejki laminowane",
    "sh.warn.lam": "Naklejki z laminatem. Przezroczysta folia chroni nadruk przed zarysowaniami, przetarciami, wodą i blaknięciem. Idealne na przedmioty, które są często dotykane i używane: butelki, kubki, laptopy. Kolory zostają intensywne znacznie dłużej.",
    "sh.added.title": "Dodano do koszyka. Masz kolejny projekt?",
    "sh.btn.next": "Konfiguruj kolejną naklejkę",
    "sh.btn.cart": "Przejdź do koszyka",
    "sh.btn.addToCart": "Do koszyka",
    "sh.btn.share": "Udostępnij ustawienia",
    "sh.btn.save": "Zapisz konfigurację",
    "sh.toast.added": "Produkt dodany do koszyka!",
    "sh.toast.maxFiles": "Maksymalnie 6 plików (3 projekty + kontury cięcia) w jednym zamówieniu.",
    "sh.toast.fileAdded": "Plik dodany",
    "sh.toast.uploadCancelled": "Wgrywanie anulowane",
    "sh.toast.uploadFailed": "Nie udało się wgrać pliku",
    "sh.toast.tryAgain": "Spróbuj ponownie.",
    "sh.toast.loginCart": "Zaloguj się, aby dodać do koszyka",
    "sh.toast.loginSave": "Zaloguj się, aby zapisać konfigurację",
    "sh.toast.namePrompt": "Nadaj nazwę konfiguracji (opcjonalnie):",
    "sh.toast.saveError": "Błąd zapisu konfiguracji",
    "sh.toast.saved": "Konfiguracja zapisana! Znajdziesz ją w koncie.",
    "sh.toast.linkCopied": "Link skopiowany do schowka!",
    "sh.toast.copyLink": "Skopiuj link:",
    "sh.cart.shapeLabel": "Naklejki hurtowe na arkuszach (bez laminatu)",
    "sh.cart.buttSuffix": " — cięcie na styk",
    "sh.cart.noLaminate": "Bez laminatu",
    "sh.cfg.defaultName": "Arkusze hurtowe",
  },

  en: {
    "sh.switch.custom.title": "Custom-size stickers",
    "sh.switch.custom.desc": "kiss-cut or die-cut, with laminate",
    "sh.switch.sheets.title": "Bulk stickers on sheets",
    "sh.switch.sheets.desc": "kiss-cut, no laminate, from 0.5 m²",
    "sh.seo.title": "Bulk stickers on sheets – priced per m² | Stickers Tattooo",
    "sh.seo.description": "Kiss-cut stickers on a sheet without laminate, priced by foil area. Minimum 0.5 m², then in 0.5 m² steps. Same print and foils as our premium stickers.",
    "sh.h1": "Bulk stickers on sheets",
    "sh.intro.1": "Kiss-cut stickers on a sheet, without laminate — for products, for sealing parcels, envelopes and packaging, or to cut into single pieces yourself.",
    "sh.intro.strong1": "The same print and the same foils as our premium stickers",
    "sh.intro.2": "— the only difference is no laminate. Priced by foil area, not per piece. Minimum 0.5 m², then in 0.5 m² steps. From 1 m² the standard per-metre rate applies.",
    "sh.intro.strong2": "You can order stickers in any shape",
    "sh.intro.3": "— rectangle, square, oval, circle or a custom contour.",
    "sh.hero.alt": "Sheet of Stickers.tattooo stickers — ready to peel off one by one or cut apart",
    "sh.foil.label": "Foil type",
    "sh.lam.label": "Lamination",
    "sh.lam.none": "No laminate",
    "sh.lam.matte": "Matte laminate",
    "sh.lam.gloss": "Gloss laminate",
    "sh.sum.laminate": "Laminate",
    "sh.foil.prices": "Gross prices for this foil:",
    "sh.foil.perHalf": "per 0.5 m²",
    "sh.foil.perM2From": "per m² from 1 m²",
    "sh.foil.netPerM2": "net / m² from 1 m²",
    "sh.foil.holoNote": "Printing on holographic foils without a white underprint stays translucent — the artwork takes on the shine of the foil. If you need true-to-life colours, message us before ordering.",
    "sh.area.label": "Area",
    "sh.area.aria": "Area in m²",
    "sh.area.small": "small format",
    "sh.area.note": "We produce the order on sheets of 0.5 m × 1 m or similar — the exact format depends on the size and layout of the stickers. For larger orders we split the print across several sheets. The total number of pieces always matches the one shown in the calculation. As a large-format print shop we can also make a sticker in any size — even several metres, in one piece. We also produce large stickers for shop windows, glass and other large-format surfaces.",
    "sh.err.foil": "Choose a foil type",
    "sh.err.minArea": "Minimum order is 0.5 m²",
    "sh.err.step": "Increase the area in 0.5 m² steps",
    "sh.err.maxArea": "Maximum area is 50 m²",
    "sh.err.dims": "Enter the sticker dimensions",
    "sh.err.minDim": "Minimum sticker dimension is 5 mm",
    "sh.err.minGap": "Minimum gap between stickers is 3 mm",
    "sh.err.noFit": "The sticker does not fit within the ordered area",
    "sh.dims.label": "Sticker dimensions",
    "sh.dims.width": "Width",
    "sh.dims.height": "Height",
    "sh.dims.unit.mm": "millimeters",
    "sh.dims.unit.cm": "centimeters",
    "sh.dims.gap": "Gap (mm)",
    "sh.gap.butt": "0 mm — butt cut",
    "sh.butt.title": "Butt cut (no gap)",
    "sh.butt.sub": "more stickers from the same area",
    "sh.butt.note": "Butt cutting applies only to square / rectangular stickers. The stickers are cut side by side, with no margin.",
    "sh.butt.unavailable": "Butt cut is available only for rectangular and square stickers.",
    "sh.stats.total": "Stickers in total",
    "sh.stats.perM2": "Stickers per 1 m²",
    "sh.file.label": "Design files",
    "sh.file.watermark": "MAX 3 DESIGNS / ORDER",
    "sh.file.uploading": "Uploading...",
    "sh.file.prompt": "Drag files here or click to choose",
    "sh.file.counterSuffix": "files",
    "sh.up.title": "Uploading your files…",
    "sh.up.wait": "Please be patient, this may take a moment.",
    "sh.up.remaining": "remaining",
    "sh.up.dontClose": "Do not close the page while uploading",
    "sh.up.cancel": "✕ Cancel upload",
    "sh.max3.title": "Maximum 3 designs in one order",
    "sh.max3.desc": "One order can contain up to 3 designs and up to 6 files — the extra files are optional cut-contour files. If you have more designs, configure another order separately and add it to the cart as a new item.",
    "sh.file.previewAlt": "Preview",
    "sh.file.remove": "Remove file",
    "sh.file.noPreview": "The file was uploaded correctly. A preview may not be available for this format.",
    "sh.notice.title": "Remember: up to 3 designs (max 6 files) per order",
    "sh.notice.desc": "If you have more files, add the rest as a separate cart item.",
    "sh.req.1a": "file at the size of the ordered area (",
    "sh.req.1b": "), with a 3 mm bleed",
    "sh.req.2": "cut lines as a separate layer or the CutContour spot colour",
    "sh.req.3": "minimum gap between stickers 3 mm",
    "sh.req.4": "up to 3 designs (max 6 files incl. cut contours) per order — add more designs as separate cart items",
    "sh.faq.title": "Frequently asked questions",
    "sh.faq.q1": "Can I cut the sheet into single stickers?",
    "sh.faq.a1": "The stickers are kiss-cut along their contour, so you peel them off the sheet one by one. If you prefer separate pieces — e.g. to include with shipments — you can cut the sheet with scissors along the gaps between the stickers. That is exactly why we leave a 3 mm margin between them.",
    "sh.faq.q2": "Why can't I set a gap smaller than 3 mm?",
    "sh.faq.a2": "Below 3 mm the plotter blade can lift the neighbouring sticker when you peel one off. It is a technical limit, not a preference.",
    "sh.faq.q3": "What are the sheet dimensions?",
    "sh.faq.a3": "We charge for area, not for format. The sheet proportions depend on the foil width available in a given batch — we guarantee the area and the number of stickers.",
    "sh.faq.q4": "How do they differ from premium stickers?",
    "sh.faq.a4": "The print and the foils are identical. The difference is the missing laminate, which makes the print less resistant to scratches and abrasion. It is still resistant to water, sun and weather.",
    "sh.faq.q5": "Can I upload several different designs in one order?",
    "sh.faq.a5": "3 designs = 1 order in the cart. One order can contain up to 3 designs and up to 6 files — the extra files are optional cut-contour files. If you have more designs, configure another order separately and add it to the cart as a new item.",
    "sh.sum.title": "Order summary",
    "sh.sum.foil": "Foil type",
    "sh.sum.area": "Area",
    "sh.sum.pricePerM2": "Price per m²",
    "sh.sum.size": "Sticker size",
    "sh.sum.gap": "Gap",
    "sh.sum.total": "Stickers in total",
    "sh.sum.surcharge": "Small sticker surcharge (+20%)",
    "sh.sum.volume": "Volume discount",
    "sh.vol.next": "Order from {a} m² to get {p}% off.",
    "sh.vol.note": "The volume discount does not combine with the welcome or individual discount — we always apply the better one.",
    "sh.sum.ship": "Dispatch by",
    "sh.sum.gross": "gross",
    "sh.sum.net": "net",
    "sh.sum.perPiece": "/ piece",
    "sh.upsell.a": "For 1 m² you pay only",
    "sh.upsell.b": " more and get twice as many stickers.",
    "sh.warn.a": "Stickers without laminate. The print is resistant to water, sun and weather — outdoors it lasts about 3 years. Without laminate, however, it is less resistant to mechanical damage: the sticker can get scratched or rubbed off. If it is going on a bottle, a mug or a laptop, where it is touched and rubbed often, choose laminated stickers",
    "sh.warn.lam": "Stickers with laminate. A transparent film protects the print against scratches, abrasion, water and fading. Perfect for items that are often touched and used: bottles, mugs, laptops. Colours stay vibrant much longer.",
    "sh.added.title": "Added to cart. Do you have another design?",
    "sh.btn.next": "Configure another sticker",
    "sh.btn.cart": "Go to cart",
    "sh.btn.addToCart": "Add to cart",
    "sh.btn.share": "Share settings",
    "sh.btn.save": "Save configuration",
    "sh.toast.added": "Product added to the cart!",
    "sh.toast.maxFiles": "Maximum 6 files (3 designs + cut contours) per order.",
    "sh.toast.fileAdded": "File added",
    "sh.toast.uploadCancelled": "Upload cancelled",
    "sh.toast.uploadFailed": "Could not upload the file",
    "sh.toast.tryAgain": "Please try again.",
    "sh.toast.loginCart": "Log in to add to the cart",
    "sh.toast.loginSave": "Log in to save the configuration",
    "sh.toast.namePrompt": "Name your configuration (optional):",
    "sh.toast.saveError": "Error saving the configuration",
    "sh.toast.saved": "Configuration saved! You will find it in your account.",
    "sh.toast.linkCopied": "Link copied to clipboard!",
    "sh.toast.copyLink": "Copy the link:",
    "sh.cart.shapeLabel": "Bulk stickers on sheets (no laminate)",
    "sh.cart.buttSuffix": " — butt cut",
    "sh.cart.noLaminate": "No laminate",
    "sh.cfg.defaultName": "Bulk sheets",
  },

  de: {
    "sh.switch.custom.title": "Aufkleber nach Maß",
    "sh.switch.custom.desc": "Kiss-Cut oder Konturschnitt, mit Laminat",
    "sh.switch.sheets.title": "Aufkleber-Großbestellung auf Bogen",
    "sh.switch.sheets.desc": "Kiss-Cut, ohne Laminat, ab 0,5 m²",
    "sh.seo.title": "Aufkleber auf Bogen – Preis pro m² | Stickers Tattooo",
    "sh.seo.description": "Kiss-Cut-Aufkleber auf dem Bogen ohne Laminat, abgerechnet nach Folienfläche. Minimum 0,5 m², weiter in 0,5-m²-Schritten. Gleicher Druck und gleiche Folien wie bei den Premium-Aufklebern.",
    "sh.h1": "Aufkleber-Großbestellung auf Bogen",
    "sh.intro.1": "Kiss-Cut-Aufkleber auf dem Bogen, ohne Laminat — für Produkte, zum Verschließen von Paketen, Umschlägen und Verpackungen oder zum selbst Zerschneiden in einzelne Stück.",
    "sh.intro.strong1": "Gleicher Druck und gleiche Folien wie bei den Premium-Aufklebern",
    "sh.intro.2": "— der Unterschied ist das fehlende Laminat. Abgerechnet wird die Folienfläche, nicht das Stück. Minimum 0,5 m², weiter in 0,5-m²-Schritten. Ab 1 m² gilt der Standardpreis pro Meter.",
    "sh.intro.strong2": "Sie können Aufkleber in jeder beliebigen Form bestellen",
    "sh.intro.3": "— Rechteck, Quadrat, Oval, Kreis oder eine individuelle Kontur.",
    "sh.hero.alt": "Aufkleberbogen von Stickers.tattooo — bereit zum einzelnen Abziehen oder Zerschneiden",
    "sh.foil.label": "Folienart",
    "sh.lam.label": "Laminat",
    "sh.lam.none": "Ohne Laminat",
    "sh.lam.matte": "Mattes Laminat",
    "sh.lam.gloss": "Glänzendes Laminat",
    "sh.sum.laminate": "Laminat",
    "sh.foil.prices": "Bruttopreise für diese Folie:",
    "sh.foil.perHalf": "für 0,5 m²",
    "sh.foil.perM2From": "pro m² ab 1 m²",
    "sh.foil.netPerM2": "netto / m² ab 1 m²",
    "sh.foil.holoNote": "Der Druck auf holografischen Folien ohne weißen Unterdruck bleibt durchscheinend — das Motiv übernimmt den Glanz der Folie. Wenn Ihnen originalgetreue Farben wichtig sind, schreiben Sie uns vor der Bestellung.",
    "sh.area.label": "Fläche",
    "sh.area.aria": "Fläche in m²",
    "sh.area.small": "kleines Format",
    "sh.area.note": "Wir fertigen die Bestellung auf Bogen von 0,5 m × 1 m oder ähnlich — das genaue Format hängt von Größe und Anordnung der Aufkleber ab. Bei größeren Bestellungen verteilen wir den Druck auf mehrere Bogen. Die Gesamtzahl der Stück entspricht immer der Angabe in der Berechnung. Als Großformatdruckerei können wir einen Aufkleber aber auch in jeder beliebigen Größe herstellen — sogar mehrere Meter groß, aus einem Stück. Wir fertigen ebenso große Aufkleber für Schaufenster, Glasflächen und andere großformatige Oberflächen.",
    "sh.err.foil": "Wählen Sie eine Folienart",
    "sh.err.minArea": "Mindestbestellung sind 0,5 m²",
    "sh.err.step": "Erhöhen Sie die Fläche in 0,5-m²-Schritten",
    "sh.err.maxArea": "Maximale Fläche sind 50 m²",
    "sh.err.dims": "Geben Sie die Aufklebermaße an",
    "sh.err.minDim": "Das Mindestmaß eines Aufklebers beträgt 5 mm",
    "sh.err.minGap": "Der Mindestabstand zwischen Aufklebern beträgt 3 mm",
    "sh.err.noFit": "Der Aufkleber passt nicht auf die bestellte Fläche",
    "sh.dims.label": "Aufklebermaße",
    "sh.dims.width": "Breite",
    "sh.dims.height": "Höhe",
    "sh.dims.unit.mm": "Millimeter",
    "sh.dims.unit.cm": "Zentimeter",
    "sh.dims.gap": "Abstand (mm)",
    "sh.gap.butt": "0 mm — auf Stoß",
    "sh.butt.title": "Schnitt auf Stoß (ohne Abstand)",
    "sh.butt.sub": "mehr Aufkleber aus derselben Fläche",
    "sh.butt.note": "Der Schnitt auf Stoß gilt nur für quadratische / rechteckige Aufkleber. Die Aufkleber werden ohne Rand direkt nebeneinander geschnitten.",
    "sh.butt.unavailable": "Der Schnitt auf Stoß ist nur für rechteckige und quadratische Aufkleber verfügbar.",
    "sh.stats.total": "Aufkleber insgesamt",
    "sh.stats.perM2": "Aufkleber pro 1 m²",
    "sh.file.label": "Design-Dateien",
    "sh.file.watermark": "MAX. 10 DATEIEN / BESTELLUNG",
    "sh.file.uploading": "Wird hochgeladen...",
    "sh.file.prompt": "Dateien hierher ziehen oder klicken zum Auswählen",
    "sh.file.counterSuffix": "Dateien",
    "sh.up.title": "Dateien werden hochgeladen…",
    "sh.up.wait": "Bitte haben Sie etwas Geduld, das kann einen Moment dauern.",
    "sh.up.remaining": "verbleibend",
    "sh.up.dontClose": "Schließen Sie die Seite während des Uploads nicht",
    "sh.up.cancel": "✕ Upload abbrechen",
    "sh.max3.title": "Maximal 3 Designs in einer Bestellung",
    "sh.max3.desc": "Eine Bestellung kann bis zu 3 Designs und maximal 6 Dateien enthalten — die zusätzlichen Dateien sind optionale Schnittkonturen. Bei mehr Designs konfigurieren Sie eine weitere Bestellung separat und legen Sie sie als zusätzliche Position in den Warenkorb.",
    "sh.file.previewAlt": "Vorschau",
    "sh.file.remove": "Datei entfernen",
    "sh.file.noPreview": "Die Datei wurde korrekt hochgeladen. Für dieses Format ist unter Umständen keine Vorschau verfügbar.",
    "sh.notice.title": "Denken Sie daran: maximal 3 Designs (bis 6 Dateien) pro Bestellung",
    "sh.notice.desc": "Wenn Sie mehr als 10 Dateien haben, fügen Sie die weiteren als separate Warenkorbposition hinzu.",
    "sh.req.1a": "Datei in der Größe der bestellten Fläche (",
    "sh.req.1b": "), mit 3 mm Beschnitt",
    "sh.req.2": "Schnittlinien als separate Ebene oder Sonderfarbe CutContour",
    "sh.req.3": "Mindestabstand zwischen Aufklebern 3 mm",
    "sh.req.4": "maximal 3 Designs (bis 6 Dateien inkl. Schnittkonturen) pro Bestellung — weitere Designs als separate Warenkorbpositionen hinzufügen",
    "sh.faq.title": "Häufige Fragen",
    "sh.faq.q1": "Kann ich den Bogen in einzelne Aufkleber schneiden?",
    "sh.faq.a1": "Die Aufkleber sind entlang der Kontur eingeschnitten, Sie ziehen sie also einzeln vom Bogen ab. Wenn Sie lieber einzelne Stück hätten — z. B. zum Beilegen in Sendungen — können Sie den Bogen mit der Schere entlang der Abstände zwischen den Aufklebern zerschneiden. Genau dafür lassen wir 3 mm Rand dazwischen.",
    "sh.faq.q2": "Warum kann ich keinen Abstand unter 3 mm einstellen?",
    "sh.faq.a2": "Unter 3 mm kann das Plottermesser beim Abziehen den benachbarten Aufkleber mit anheben. Das ist eine technische Grenze, keine Vorliebe.",
    "sh.faq.q3": "Welche Maße hat der Bogen?",
    "sh.faq.a3": "Wir rechnen die Fläche ab, nicht das Format. Die Proportionen des Bogens hängen von der Folienbreite der jeweiligen Charge ab — garantiert sind Fläche und Aufkleberanzahl.",
    "sh.faq.q4": "Worin unterscheiden sie sich von Premium-Aufklebern?",
    "sh.faq.a4": "Druck und Folien sind identisch. Der Unterschied ist das fehlende Laminat, wodurch der Druck weniger widerstandsfähig gegen Kratzer und Abrieb ist. Gegen Wasser, Sonne und Witterung ist er weiterhin beständig.",
    "sh.faq.q5": "Kann ich mehrere verschiedene Designs in einer Bestellung hochladen?",
    "sh.faq.a5": "3 Designs = 1 Bestellung im Warenkorb. Eine Bestellung kann bis zu 3 Designs und maximal 6 Dateien enthalten — die zusätzlichen Dateien sind optionale Schnittkonturen. Bei mehr Designs konfigurieren Sie eine weitere Bestellung separat und legen Sie sie als zusätzliche Position in den Warenkorb.",
    "sh.sum.title": "Bestellübersicht",
    "sh.sum.foil": "Folienart",
    "sh.sum.area": "Fläche",
    "sh.sum.pricePerM2": "Preis pro m²",
    "sh.sum.size": "Aufklebermaß",
    "sh.sum.gap": "Abstand",
    "sh.sum.total": "Aufkleber insgesamt",
    "sh.sum.surcharge": "Aufschlag für kleine Aufkleber (+20%)",
    "sh.sum.volume": "Mengenrabatt",
    "sh.vol.next": "Bestellen Sie ab {a} m² und erhalten Sie {p}% Rabatt.",
    "sh.vol.note": "Der Mengenrabatt ist nicht mit dem Willkommens- oder Individualrabatt kombinierbar — es gilt immer der günstigere.",
    "sh.sum.ship": "Versand bis",
    "sh.sum.gross": "brutto",
    "sh.sum.net": "netto",
    "sh.sum.perPiece": "/ Stück",
    "sh.upsell.a": "Für 1 m² zahlen Sie nur",
    "sh.upsell.b": " mehr und erhalten doppelt so viele Aufkleber.",
    "sh.warn.lam": "Aufkleber mit Laminat. Eine transparente Folie schützt den Druck vor Kratzern, Abrieb, Wasser und Ausbleichen. Ideal für Gegenstände, die oft angefasst und benutzt werden: Flaschen, Tassen, Laptops. Die Farben bleiben deutlich länger intensiv.",
    "sh.warn.a": "Aufkleber ohne Laminat. Der Druck ist beständig gegen Wasser, Sonne und Witterung — im Außenbereich hält er etwa 3 Jahre. Ohne Laminat ist er jedoch weniger widerstandsfähig gegen mechanische Beschädigungen: Der Aufkleber kann zerkratzen oder sich abreiben. Wenn er auf eine Flasche, eine Tasse oder einen Laptop soll, also dorthin, wo er oft berührt und gerieben wird, wählen Sie laminierte Aufkleber",
    "sh.added.title": "In den Warenkorb gelegt. Haben Sie ein weiteres Design?",
    "sh.btn.next": "Weiteren Aufkleber konfigurieren",
    "sh.btn.cart": "Zum Warenkorb",
    "sh.btn.addToCart": "In den Warenkorb",
    "sh.btn.share": "Einstellungen teilen",
    "sh.btn.save": "Konfiguration speichern",
    "sh.toast.added": "Produkt in den Warenkorb gelegt!",
    "sh.toast.maxFiles": "Maximal 6 Dateien (3 Designs + Schnittkonturen) pro Bestellung.",
    "sh.toast.fileAdded": "Datei hinzugefügt",
    "sh.toast.uploadCancelled": "Upload abgebrochen",
    "sh.toast.uploadFailed": "Datei konnte nicht hochgeladen werden",
    "sh.toast.tryAgain": "Bitte versuchen Sie es erneut.",
    "sh.toast.loginCart": "Melden Sie sich an, um in den Warenkorb zu legen",
    "sh.toast.loginSave": "Melden Sie sich an, um die Konfiguration zu speichern",
    "sh.toast.namePrompt": "Geben Sie der Konfiguration einen Namen (optional):",
    "sh.toast.saveError": "Fehler beim Speichern der Konfiguration",
    "sh.toast.saved": "Konfiguration gespeichert! Sie finden sie in Ihrem Konto.",
    "sh.toast.linkCopied": "Link in die Zwischenablage kopiert!",
    "sh.toast.copyLink": "Link kopieren:",
    "sh.cart.shapeLabel": "Aufkleber-Großbestellung auf Bogen (ohne Laminat)",
    "sh.cart.buttSuffix": " — Schnitt auf Stoß",
    "sh.cart.noLaminate": "Ohne Laminat",
    "sh.cfg.defaultName": "Großbestellung Bogen",
  },

  it: {
    "sh.switch.custom.title": "Adesivi su misura",
    "sh.switch.custom.desc": "kiss-cut o fustellato, con laminato",
    "sh.switch.sheets.title": "Adesivi all'ingrosso su fogli",
    "sh.switch.sheets.desc": "kiss-cut, senza laminato, da 0,5 m²",
    "sh.seo.title": "Adesivi all'ingrosso su fogli – prezzo al m² | Stickers Tattooo",
    "sh.seo.description": "Adesivi kiss-cut sul foglio senza laminato, calcolati sulla superficie della pellicola. Minimo 0,5 m², poi a step di 0,5 m². Stessa stampa e stesse pellicole degli adesivi premium.",
    "sh.h1": "Adesivi all'ingrosso su fogli",
    "sh.intro.1": "Adesivi kiss-cut sul foglio, senza laminato — per i prodotti, per chiudere pacchi, buste e imballaggi o da tagliare tu stesso in pezzi singoli.",
    "sh.intro.strong1": "Stessa stampa e stesse pellicole degli adesivi premium",
    "sh.intro.2": "— l'unica differenza è l'assenza del laminato. Il calcolo è sulla superficie della pellicola, non sul pezzo. Minimo 0,5 m², poi a step di 0,5 m². Da 1 m² si applica la tariffa standard al metro.",
    "sh.intro.strong2": "Puoi ordinare adesivi in qualsiasi forma",
    "sh.intro.3": "— rettangolo, quadrato, ovale, cerchio o un contorno personalizzato.",
    "sh.hero.alt": "Foglio di adesivi Stickers.tattooo — pronti da staccare uno a uno o da tagliare",
    "sh.foil.label": "Tipo di pellicola",
    "sh.lam.label": "Laminato",
    "sh.lam.none": "Senza laminato",
    "sh.lam.matte": "Laminato opaco",
    "sh.lam.gloss": "Laminato lucido",
    "sh.sum.laminate": "Laminato",
    "sh.foil.prices": "Prezzi lordi per questa pellicola:",
    "sh.foil.perHalf": "per 0,5 m²",
    "sh.foil.perM2From": "al m² da 1 m²",
    "sh.foil.netPerM2": "netto / m² da 1 m²",
    "sh.foil.holoNote": "La stampa su pellicole olografiche senza fondo bianco resta traslucida — la grafica assume la lucentezza della pellicola. Se ti servono colori fedeli, scrivici prima di ordinare.",
    "sh.area.label": "Superficie",
    "sh.area.aria": "Superficie in m²",
    "sh.area.small": "piccolo formato",
    "sh.area.note": "Realizziamo l'ordine su fogli da 0,5 m × 1 m o simili — il formato esatto dipende dalla dimensione e dalla disposizione degli adesivi. Per ordini più grandi dividiamo la stampa su più fogli. Il numero totale di pezzi corrisponde sempre a quello indicato nel calcolo. Come stampa di grande formato possiamo però realizzare un adesivo di qualsiasi dimensione — anche di diversi metri, in un unico pezzo. Produciamo anche grandi adesivi per vetrine, vetri e altre superfici di grande formato.",
    "sh.err.foil": "Scegli il tipo di pellicola",
    "sh.err.minArea": "L'ordine minimo è 0,5 m²",
    "sh.err.step": "Aumenta la superficie a step di 0,5 m²",
    "sh.err.maxArea": "La superficie massima è 50 m²",
    "sh.err.dims": "Inserisci le dimensioni dell'adesivo",
    "sh.err.minDim": "La dimensione minima dell'adesivo è 5 mm",
    "sh.err.minGap": "La distanza minima tra gli adesivi è 3 mm",
    "sh.err.noFit": "L'adesivo non entra nella superficie ordinata",
    "sh.dims.label": "Dimensioni dell'adesivo",
    "sh.dims.width": "Larghezza",
    "sh.dims.height": "Altezza",
    "sh.dims.unit.mm": "millimetri",
    "sh.dims.unit.cm": "centimetri",
    "sh.dims.gap": "Distanza (mm)",
    "sh.gap.butt": "0 mm — taglio a contatto",
    "sh.butt.title": "Taglio a contatto (senza distanza)",
    "sh.butt.sub": "più adesivi dalla stessa superficie",
    "sh.butt.note": "Il taglio a contatto vale solo per adesivi quadrati / rettangolari. Gli adesivi vengono tagliati uno accanto all'altro, senza margine.",
    "sh.butt.unavailable": "Il taglio a contatto è disponibile solo per adesivi rettangolari e quadrati.",
    "sh.stats.total": "Adesivi in totale",
    "sh.stats.perM2": "Adesivi per 1 m²",
    "sh.file.label": "File del progetto",
    "sh.file.watermark": "MAX 3 PROGETTI / ORDINE",
    "sh.file.uploading": "Caricamento...",
    "sh.file.prompt": "Trascina i file o clicca per sceglierli",
    "sh.file.counterSuffix": "file",
    "sh.up.title": "Caricamento dei file in corso…",
    "sh.up.wait": "Un attimo di pazienza, potrebbe volerci un momento.",
    "sh.up.remaining": "rimanenti",
    "sh.up.dontClose": "Non chiudere la pagina durante il caricamento",
    "sh.up.cancel": "✕ Annulla caricamento",
    "sh.max3.title": "Massimo 3 progetti in un ordine",
    "sh.max3.desc": "Un ordine può contenere fino a 3 progetti e massimo 6 file — i file aggiuntivi sono eventuali contorni di taglio. Se hai altri progetti, configura un altro ordine separatamente e aggiungilo al carrello come nuova voce.",
    "sh.file.previewAlt": "Anteprima",
    "sh.file.remove": "Rimuovi file",
    "sh.file.noPreview": "Il file è stato caricato correttamente. Per questo formato l'anteprima potrebbe non essere disponibile.",
    "sh.notice.title": "Ricorda: massimo 3 progetti (fino a 6 file) per ordine",
    "sh.notice.desc": "Se hai più di 10 file, aggiungi gli altri come voce separata nel carrello.",
    "sh.req.1a": "file nelle dimensioni della superficie ordinata (",
    "sh.req.1b": "), con 3 mm di abbondanza",
    "sh.req.2": "linee di taglio come livello separato o tinta piatta CutContour",
    "sh.req.3": "distanza minima tra gli adesivi 3 mm",
    "sh.req.4": "massimo 3 progetti (fino a 6 file inclusi i contorni di taglio) per ordine — aggiungi altri progetti come voci separate nel carrello",
    "sh.faq.title": "Domande frequenti",
    "sh.faq.q1": "Posso tagliare il foglio in singoli adesivi?",
    "sh.faq.a1": "Gli adesivi sono incisi lungo il contorno, quindi li stacchi uno a uno dal foglio. Se preferisci pezzi separati — ad esempio da inserire nelle spedizioni — puoi tagliare il foglio con le forbici lungo gli spazi tra gli adesivi. Proprio per questo lasciamo 3 mm di margine tra di loro.",
    "sh.faq.q2": "Perché non posso impostare una distanza inferiore a 3 mm?",
    "sh.faq.a2": "Sotto i 3 mm la lama del plotter può sollevare l'adesivo vicino quando ne stacchi uno. È un limite tecnico, non una preferenza.",
    "sh.faq.q3": "Che dimensioni ha il foglio?",
    "sh.faq.a3": "Calcoliamo la superficie, non il formato. Le proporzioni del foglio dipendono dalla larghezza della pellicola disponibile nel lotto — garantiamo la superficie e il numero di adesivi.",
    "sh.faq.q4": "In cosa differiscono dagli adesivi premium?",
    "sh.faq.a4": "La stampa e le pellicole sono identiche. La differenza è l'assenza del laminato, per cui la stampa è meno resistente a graffi e abrasioni. Resta comunque resistente ad acqua, sole e intemperie.",
    "sh.faq.q5": "Posso caricare più progetti diversi in un solo ordine?",
    "sh.faq.a5": "3 progetti = 1 ordine nel carrello. Un ordine può contenere fino a 3 progetti e massimo 6 file — i file aggiuntivi sono eventuali contorni di taglio. Se hai altri progetti, configura un altro ordine separatamente e aggiungilo al carrello come nuova voce.",
    "sh.sum.title": "Riepilogo dell'ordine",
    "sh.sum.foil": "Tipo di pellicola",
    "sh.sum.area": "Superficie",
    "sh.sum.pricePerM2": "Prezzo al m²",
    "sh.sum.size": "Dimensione dell'adesivo",
    "sh.sum.gap": "Distanza",
    "sh.sum.total": "Adesivi in totale",
    "sh.sum.surcharge": "Supplemento per adesivi piccoli (+20%)",
    "sh.sum.volume": "Sconto quantità",
    "sh.vol.next": "Ordina da {a} m² per ottenere il {p}% di sconto.",
    "sh.vol.note": "Lo sconto quantità non è cumulabile con lo sconto di benvenuto o individuale — applichiamo sempre il più conveniente.",
    "sh.sum.ship": "Spedizione entro",
    "sh.sum.gross": "lordo",
    "sh.sum.net": "netto",
    "sh.sum.perPiece": "/ pezzo",
    "sh.upsell.a": "Per 1 m² paghi solo",
    "sh.warn.lam": "Adesivi con laminato. Una pellicola trasparente protegge la stampa da graffi, abrasioni, acqua e sbiadimento. Ideale per oggetti toccati e usati spesso: bottiglie, tazze, laptop. I colori restano intensi molto più a lungo.",
    "sh.upsell.b": " in più e ricevi il doppio degli adesivi.",
    "sh.warn.a": "Adesivi senza laminato. La stampa resiste ad acqua, sole e intemperie — all'esterno dura circa 3 anni. L'assenza del laminato significa però minore resistenza ai danni meccanici: l'adesivo può graffiarsi o consumarsi. Se finirà su una bottiglia, una tazza o un laptop, cioè dove viene toccato e sfregato spesso, scegli gli adesivi laminati",
    "sh.added.title": "Aggiunto al carrello. Hai un altro progetto?",
    "sh.btn.next": "Configura un altro adesivo",
    "sh.btn.cart": "Vai al carrello",
    "sh.btn.addToCart": "Aggiungi al carrello",
    "sh.btn.share": "Condividi le impostazioni",
    "sh.btn.save": "Salva la configurazione",
    "sh.toast.added": "Prodotto aggiunto al carrello!",
    "sh.toast.maxFiles": "Massimo 6 file (3 progetti + contorni di taglio) per ordine.",
    "sh.toast.fileAdded": "File aggiunto",
    "sh.toast.uploadCancelled": "Caricamento annullato",
    "sh.toast.uploadFailed": "Impossibile caricare il file",
    "sh.toast.tryAgain": "Riprova.",
    "sh.toast.loginCart": "Accedi per aggiungere al carrello",
    "sh.toast.loginSave": "Accedi per salvare la configurazione",
    "sh.toast.namePrompt": "Dai un nome alla configurazione (facoltativo):",
    "sh.toast.saveError": "Errore nel salvataggio della configurazione",
    "sh.toast.saved": "Configurazione salvata! La trovi nel tuo account.",
    "sh.toast.linkCopied": "Link copiato negli appunti!",
    "sh.toast.copyLink": "Copia il link:",
    "sh.cart.shapeLabel": "Adesivi all'ingrosso su fogli (senza laminato)",
    "sh.cart.buttSuffix": " — taglio a contatto",
    "sh.cart.noLaminate": "Senza laminato",
    "sh.cfg.defaultName": "Fogli all'ingrosso",
  },

  fr: {
    "sh.switch.custom.title": "Autocollants sur mesure",
    "sh.switch.custom.desc": "découpe kiss-cut ou à la forme, avec pellicule de lamination",
    "sh.switch.sheets.title": "Autocollants en gros sur feuilles",
    "sh.switch.sheets.desc": "découpe kiss-cut, sans lamination, à partir de 0,5 m²",
    "sh.seo.title": "Autocollants en gros sur feuilles – prix au m² | Stickers Tattooo",
    "sh.seo.description": "Autocollants en découpe kiss-cut sur feuille, sans lamination, facturés à la surface du film. Minimum 0,5 m², puis par paliers de 0,5 m². Même impression et mêmes films que nos autocollants premium.",
    "sh.h1": "Autocollants en gros sur feuilles",
    "sh.intro.1": "Autocollants en découpe kiss-cut sur feuille, sans lamination — pour vos produits, pour fermer colis, enveloppes et emballages, ou à découper vous-même en pièces.",
    "sh.intro.strong1": "La même impression et les mêmes films que nos autocollants premium",
    "sh.intro.2": "— la seule différence est l'absence de pellicule de lamination. Facturation à la surface du film, pas à la pièce. Minimum 0,5 m², puis par paliers de 0,5 m². À partir de 1 m², le tarif standard au mètre s'applique.",
    "sh.intro.strong2": "Vous pouvez commander des autocollants de n'importe quelle forme",
    "sh.intro.3": "— rectangle, carré, ovale, cercle ou contour personnalisé.",
    "sh.hero.alt": "Feuille d'autocollants Stickers.tattooo — prêts à décoller un à un ou à découper",
    "sh.foil.label": "Type de film",
    "sh.lam.label": "Lamination",
    "sh.lam.none": "Sans lamination",
    "sh.lam.matte": "Lamination mate",
    "sh.lam.gloss": "Lamination brillante",
    "sh.sum.laminate": "Lamination",
    "sh.foil.prices": "Prix TTC pour ce film :",
    "sh.foil.perHalf": "pour 0,5 m²",
    "sh.foil.perM2From": "par m² à partir de 1 m²",
    "sh.foil.netPerM2": "HT / m² à partir de 1 m²",
    "sh.foil.holoNote": "L'impression sur films holographiques sans fond blanc reste translucide — le visuel prend les reflets du film. Si vous tenez à des couleurs fidèles, écrivez-nous avant de commander.",
    "sh.area.label": "Surface",
    "sh.area.aria": "Surface en m²",
    "sh.area.small": "petit format",
    "sh.area.note": "Nous réalisons la commande sur des feuilles de 0,5 m × 1 m ou approchantes — le format exact dépend de la taille et de la disposition des autocollants. Pour les grandes commandes, nous répartissons l'impression sur plusieurs feuilles. Le nombre total de pièces correspond toujours à celui indiqué dans le calcul. En tant qu'imprimerie grand format, nous pouvons aussi réaliser un autocollant de n'importe quelle taille — même de plusieurs mètres, d'une seule pièce. Nous produisons également de grands autocollants pour vitrines, vitres et autres surfaces grand format.",
    "sh.err.foil": "Choisissez un type de film",
    "sh.err.minArea": "La commande minimale est de 0,5 m²",
    "sh.err.step": "Augmentez la surface par paliers de 0,5 m²",
    "sh.err.maxArea": "La surface maximale est de 50 m²",
    "sh.err.dims": "Indiquez les dimensions de l'autocollant",
    "sh.err.minDim": "La dimension minimale d'un autocollant est de 5 mm",
    "sh.err.minGap": "L'écart minimal entre les autocollants est de 3 mm",
    "sh.err.noFit": "L'autocollant ne tient pas dans la surface commandée",
    "sh.dims.label": "Dimensions de l'autocollant",
    "sh.dims.width": "Largeur",
    "sh.dims.height": "Hauteur",
    "sh.dims.unit.mm": "millimètres",
    "sh.dims.unit.cm": "centimètres",
    "sh.dims.gap": "Écart (mm)",
    "sh.gap.butt": "0 mm — bord à bord",
    "sh.butt.title": "Découpe bord à bord (sans écart)",
    "sh.butt.sub": "plus d'autocollants pour la même surface",
    "sh.butt.note": "La découpe bord à bord ne s'applique qu'aux autocollants carrés / rectangulaires. Les autocollants sont découpés côte à côte, sans marge.",
    "sh.butt.unavailable": "La découpe bord à bord n'est disponible que pour les autocollants rectangulaires et carrés.",
    "sh.stats.total": "Autocollants au total",
    "sh.stats.perM2": "Autocollants par 1 m²",
    "sh.file.label": "Fichiers du projet",
    "sh.file.watermark": "MAX 3 VISUELS / COMMANDE",
    "sh.file.uploading": "Envoi en cours...",
    "sh.file.prompt": "Glissez des fichiers ou cliquez pour les choisir",
    "sh.file.counterSuffix": "fichiers",
    "sh.up.title": "Envoi des fichiers en cours…",
    "sh.up.wait": "Merci de patienter, cela peut prendre un moment.",
    "sh.up.remaining": "restant",
    "sh.up.dontClose": "Ne fermez pas la page pendant l'envoi",
    "sh.up.cancel": "✕ Annuler l'envoi",
    "sh.max3.title": "3 visuels maximum par commande",
    "sh.max3.desc": "Une commande peut contenir jusqu'à 3 visuels et 6 fichiers maximum — les fichiers supplémentaires sont les éventuels contours de découpe. Si vous avez plus de visuels, configurez une autre commande séparément et ajoutez-la au panier comme nouvelle ligne.",
    "sh.file.previewAlt": "Aperçu",
    "sh.file.remove": "Supprimer le fichier",
    "sh.file.noPreview": "Le fichier a bien été envoyé. L'aperçu peut ne pas être disponible pour ce format.",
    "sh.notice.title": "À retenir : maximum 3 visuels (jusqu'à 6 fichiers) par commande",
    "sh.notice.desc": "Si vous avez plus de 10 fichiers, ajoutez les autres comme nouvelle ligne dans le panier.",
    "sh.req.1a": "fichier à la taille de la surface commandée (",
    "sh.req.1b": "), avec 3 mm de fond perdu",
    "sh.req.2": "lignes de découpe sur un calque séparé ou en ton direct CutContour",
    "sh.req.3": "écart minimal entre les autocollants : 3 mm",
    "sh.req.4": "maximum 3 visuels (jusqu'à 6 fichiers avec contours de découpe) par commande — ajoutez les autres visuels comme lignes distinctes dans le panier",
    "sh.faq.title": "Questions fréquentes",
    "sh.faq.q1": "Puis-je découper la feuille en autocollants individuels ?",
    "sh.faq.a1": "Les autocollants sont prédécoupés le long du contour, vous les décollez donc un à un de la feuille. Si vous préférez des pièces séparées — par exemple à glisser dans vos colis — vous pouvez couper la feuille aux ciseaux le long des écarts entre les autocollants. C'est justement pour cela que nous laissons 3 mm de marge entre eux.",
    "sh.faq.q2": "Pourquoi ne puis-je pas régler un écart inférieur à 3 mm ?",
    "sh.faq.a2": "En dessous de 3 mm, la lame du traceur peut soulever l'autocollant voisin au moment du décollage. C'est une limite technique, pas une préférence.",
    "sh.faq.q3": "Quelles sont les dimensions de la feuille ?",
    "sh.faq.a3": "Nous facturons la surface, pas le format. Les proportions de la feuille dépendent de la largeur du film disponible dans le lot — nous garantissons la surface et le nombre d'autocollants.",
    "sh.faq.q4": "En quoi diffèrent-ils des autocollants premium ?",
    "sh.faq.a4": "L'impression et les films sont identiques. La différence est l'absence de pellicule de lamination, ce qui rend l'impression moins résistante aux rayures et à l'abrasion. Elle reste toutefois résistante à l'eau, au soleil et aux intempéries.",
    "sh.faq.q5": "Puis-je envoyer plusieurs projets différents dans une seule commande ?",
    "sh.faq.a5": "3 visuels = 1 commande dans le panier. Une commande peut contenir jusqu'à 3 visuels et 6 fichiers maximum — les fichiers supplémentaires sont les éventuels contours de découpe. Si vous avez plus de visuels, configurez une autre commande séparément et ajoutez-la au panier comme nouvelle ligne.",
    "sh.sum.title": "Récapitulatif de la commande",
    "sh.sum.foil": "Type de film",
    "sh.sum.area": "Surface",
    "sh.sum.pricePerM2": "Prix au m²",
    "sh.sum.size": "Taille de l'autocollant",
    "sh.sum.gap": "Écart",
    "sh.sum.total": "Autocollants au total",
    "sh.sum.surcharge": "Supplément petits autocollants (+20 %)",
    "sh.sum.volume": "Remise sur volume",
    "sh.vol.next": "Commandez à partir de {a} m² pour obtenir {p} % de remise.",
    "sh.vol.note": "La remise sur volume ne se cumule pas avec la remise de bienvenue ou individuelle — nous appliquons la plus avantageuse.",
    "sh.sum.ship": "Expédition avant le",
    "sh.sum.gross": "TTC",
    "sh.sum.net": "HT",
    "sh.sum.perPiece": "/ pièce",
    "sh.warn.lam": "Autocollants avec lamination. Un film transparent protège l'impression contre les rayures, les frottements, l'eau et la décoloration. Idéal pour les objets souvent touchés et utilisés : bouteilles, tasses, ordinateurs portables. Les couleurs restent intenses beaucoup plus longtemps.",
    "sh.upsell.a": "Pour 1 m², vous ne payez que",
    "sh.upsell.b": " de plus et recevez deux fois plus d'autocollants.",
    "sh.warn.a": "Autocollants sans lamination. L'impression résiste à l'eau, au soleil et aux intempéries — à l'extérieur, elle tient environ 3 ans. Sans pellicule de lamination, elle est toutefois moins résistante aux dommages mécaniques : l'autocollant peut se rayer ou s'user. S'il est destiné à une bouteille, une tasse ou un ordinateur portable, là où il est souvent touché et frotté, choisissez les autocollants laminés",
    "sh.added.title": "Ajouté au panier. Vous avez un autre projet ?",
    "sh.btn.next": "Configurer un autre autocollant",
    "sh.btn.cart": "Aller au panier",
    "sh.btn.addToCart": "Ajouter au panier",
    "sh.btn.share": "Partager les réglages",
    "sh.btn.save": "Enregistrer la configuration",
    "sh.toast.added": "Produit ajouté au panier !",
    "sh.toast.maxFiles": "6 fichiers maximum (3 visuels + contours de découpe) par commande.",
    "sh.toast.fileAdded": "Fichier ajouté",
    "sh.toast.uploadCancelled": "Envoi annulé",
    "sh.toast.uploadFailed": "Impossible d'envoyer le fichier",
    "sh.toast.tryAgain": "Veuillez réessayer.",
    "sh.toast.loginCart": "Connectez-vous pour ajouter au panier",
    "sh.toast.loginSave": "Connectez-vous pour enregistrer la configuration",
    "sh.toast.namePrompt": "Donnez un nom à la configuration (facultatif) :",
    "sh.toast.saveError": "Erreur lors de l'enregistrement de la configuration",
    "sh.toast.saved": "Configuration enregistrée ! Vous la retrouverez dans votre compte.",
    "sh.toast.linkCopied": "Lien copié dans le presse-papiers !",
    "sh.toast.copyLink": "Copiez le lien :",
    "sh.cart.shapeLabel": "Autocollants en gros sur feuilles (sans lamination)",
    "sh.cart.buttSuffix": " — découpe bord à bord",
    "sh.cart.noLaminate": "Sans lamination",
    "sh.cfg.defaultName": "Feuilles en gros",
  },
} as const;
